/**
 * Bezorggarantie toggle
 * - Geen paginaherlading meer: de winkelwagen (drawer) blijft gewoon open.
 * - Na toevoegen/verwijderen wordt alleen het subtotaal-bedrag live bijgewerkt.
 * - De toggle zelf blijft gewoon aan/uit staan zoals de klant 'm heeft gezet
 *   (browser-gedrag), dus daar hoeven we niets voor te doen.
 */
(function () {
  if (window.companusShippingProtectionInitialized) return;
  window.companusShippingProtectionInitialized = true;
  function formatEuro(cents) {
    var amount = (cents / 100).toFixed(2).replace('.', ',');
    return '\u20AC' + amount + ' EUR';
  }

  function updateSubtotalDisplay(totalCents) {
    var nodes = document.querySelectorAll('.totals__subtotal-value');
    nodes.forEach(function (node) {
      node.textContent = formatEuro(totalCents);
    });
  }

  async function refreshCartTotal() {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error('Kon winkelwagen niet ophalen');
    const cart = await res.json();
    updateSubtotalDisplay(cart.total_price);
    return cart;
  }

  async function addProtection(variantId, toggleEl) {
    toggleEl.disabled = true;
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      if (!res.ok) throw new Error('Toevoegen mislukt');
      await refreshCartTotal();
    } catch (err) {
      console.error(err);
      toggleEl.checked = false;
      alert('De bezorggarantie kon niet worden toegevoegd. Probeer het opnieuw.');
    } finally {
      toggleEl.disabled = false;
    }
  }

  async function removeProtection(variantId, toggleEl) {
    toggleEl.disabled = true;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 0 }),
      });
      if (!res.ok) throw new Error('Verwijderen mislukt');
      const cart = await res.json();
      updateSubtotalDisplay(cart.total_price);
    } catch (err) {
      console.error(err);
      toggleEl.checked = true;
      alert('De bezorggarantie kon niet worden verwijderd. Probeer het opnieuw.');
    } finally {
      toggleEl.disabled = false;
    }
  }

  document.addEventListener('change', function (e) {
    const input = e.target;
    if (!input.matches || !input.matches('[data-shipping-protection-input]')) return;

    const block = input.closest('[data-shipping-protection]');
    if (!block) return;
    const variantId = block.getAttribute('data-variant-id');
    if (!variantId) return;

    if (input.checked) {
      addProtection(variantId, input);
    } else {
      removeProtection(variantId, input);
    }
  });
})();